import React from "react";
import { Badge } from "@/dentlab/src/components/ui/badge";
import { cn } from "@/dentlab/src/lib/utils";
import { ChevronDown } from "lucide-react";
import {
	DeliveryStatusEnum,
	DELIVERY_STATUS_LABELS,
} from "@/lib/types/delivery.types";

interface DeliveryStatusBadgeProps {
	status: DeliveryStatusEnum;
	id?: number;
	showChevron?: boolean;
}

const statusClasses: Record<DeliveryStatusEnum, string> = {
	[DeliveryStatusEnum.PENDING]: "bg-gray-100 text-gray-700 border-gray-200",
	[DeliveryStatusEnum.IN_TRANSIT]:
		"bg-yellow-100 text-yellow-800 border-yellow-200",
	[DeliveryStatusEnum.DELIVERED]:
		"bg-green-100 text-green-800 border-green-200",
	[DeliveryStatusEnum.FAILED]: "bg-red-100 text-red-800 border-red-200",
};

export const DeliveryStatusBadge: React.FC<DeliveryStatusBadgeProps> = ({
	status,
	id,
	showChevron,
}) => {
	return (
		<Badge
			variant="outline"
			className={cn("text-sm px-2.5 py-1 gap-1", statusClasses[status])}
			data-testid={
				id !== undefined ? `delivery-status-badge-${id}` : undefined
			}
		>
			{DELIVERY_STATUS_LABELS[status]}
			{showChevron && <ChevronDown className="h-3 w-3 opacity-60" />}
		</Badge>
	);
};
